<ng-container #pseudoModalContainer></ng-container>

<app-user-profile [hidden]="hasPseudoModal" [taskProcessContext]="taskProcessContext"></app-user-profile>

<app-task-process-custom-fields [hidden]="hasPseudoModal" [taskProcessContext]="taskProcessContext">
</app-task-process-custom-fields>
